import styled from 'styled-components';
import { size } from 'polished';
import { Icon } from '../../atoms/Icon/Icon';
import { Button } from '../../molecules/Button/Button';
import { MediaQuery } from '../../../styles/mediaQuery';
import { respondTo } from '../../../styles/helpers/respondTo';

export const StyledFallbackMap = styled.div`
  ${size('100%')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledMessageWrapper = styled.div`
  width: calc(100% - 2.5rem);
  max-width: 40rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: 0 4px 20px rgba(48, 76, 178, 0.2);
  text-align: center;
  padding: 1.875rem;

  strong {
    display: block;
  }

  @media ${respondTo(MediaQuery.XLarge)} {
    width: 100%;
    padding: 2.5rem;
  }
`;

export const StyledClockIcon = styled(Icon.Clock)`
  ${size('2.625rem')};
  margin-bottom: 0.625rem;
  color: ${({ theme }) => theme.color.orange};
`;

export const StyledButton = styled(Button)`
  margin-top: 1.875rem;
`;
